export default __webpack_public_path__ + "static/media/beautiful-woman.bcedfe65.png";